import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M17.9.586c-.1-.195-.3-.39-.5-.488C17.3 0 17.1 0 17 0h-5c-.6 0-1 .39-1 .977s.4.978 1 .978h2.6L.3 15.935a.93.93 0 0 0 0 1.368c.2.196.4.293.7.293s.5-.097.7-.293L16 3.323v2.542c0 .587.4.978 1 .978s1-.39 1-.978V.978c0-.097 0-.293-.1-.39zM17.4 17.5c.2-.098.4-.294.5-.49.1-.097.1-.293.1-.39v-4.888c0-.587-.4-.978-1-.978s-1 .391-1 .978v2.542L1.7.293a.98.98 0 0 0-1.4 0C.1.49 0 .684 0 .978c0 .293.1.488.3.684l14.3 13.98H12c-.6 0-1 .39-1 .977 0 .586.4.977 1 .977h5c.1 0 .3 0 .4-.097"
    }, null, -1)
  ]))]))
}
export default { render: render }